import React from "react";

export const ArrowUp = ({ color = "#930500", size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_up"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="14"
      height="14"
    >
      <rect
        x="13.963"
        y="13.9629"
        width="13.963"
        height="13.963"
        transform="rotate(-180 13.963 13.9629)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_up)">
      <path
        d="M6.45834 4.79966L3.53484 7.72315L2.79306 6.98137L6.98195 2.79248L11.1708 6.98137L10.4291 7.72315L7.50556 4.79966L7.50556 11.1703H6.45834L6.45834 4.79966Z"
        fill={color}
      />
    </g>
  </svg>
);

export const ArrowDown = ({ color = "#04580F", size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_down"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="14"
      height="14"
    >
      <rect
        width="13.963"
        height="13.963"
        transform="matrix(-1 0 0 1 13.963 0)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_down)">
      <path
        d="M6.45834 9.16323L3.53484 6.23974L2.79306 6.98152L6.98195 11.1704L11.1708 6.98152L10.4291 6.23974L7.50556 9.16323L7.50556 2.79263H6.45834L6.45834 9.16323Z"
        fill={color}
      />
    </g>
  </svg>
);

export const ArrowNoChange = ({ color = "#686868", size = 14 }) => (
  <svg
    width={size}
    height={size - 3}
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.77608 3.44552C5.90582 3.31579 5.96479 3.15067 5.96479 2.98556C5.96479 2.82044 5.90582 2.65533 5.77608 2.52559L3.44088 0.190393C3.19321 -0.0572795 2.78042 -0.0572795 2.52095 0.190393L0.185755 2.53739C-0.0619182 2.78506 -0.0619182 3.19785 0.185755 3.45731C0.433427 3.70499 0.846215 3.70499 1.10568 3.45731L2.34405 2.21895V9.66093C2.34405 10.0147 2.63889 10.3096 2.99271 10.3096C3.34653 10.3096 3.64138 10.0147 3.64138 9.66093V2.21895L4.87974 3.45731C5.11562 3.70499 5.52841 3.70499 5.77608 3.44552Z"
      fill={color}
    />
    <path
      d="M11.0128 6.86407C10.7651 6.6164 10.3523 6.6164 10.0929 6.86407L8.86631 8.09064V0.648667C8.86631 0.294849 8.57146 0 8.21765 0C7.86383 0 7.56898 0.294849 7.56898 0.648667V8.09064L6.33062 6.86407C6.08294 6.6164 5.67015 6.6164 5.41069 6.86407C5.28095 6.99381 5.22198 7.15892 5.22198 7.32404C5.22198 7.48915 5.28095 7.65427 5.41069 7.784L7.74589 10.1192C7.99356 10.3669 8.40635 10.3669 8.66582 10.1192L11.001 7.784C11.2605 7.52453 11.2605 7.11175 11.0128 6.86407Z"
      fill={color}
    />
  </svg>
);
